import { Tabs, TabsProps } from "antd";
import styled from "styled-components";
import { useEffect } from "react";
import EmployeeWorktime from "./employee-worktime";
import EmployeeClosure from "./employee-closure";

const TabsStyled = styled(Tabs)`
  flex: 1;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
  }
`

function EmployeeSettlement({ subpage, subSubPage, setSubPage, employeeId, employee }) {

  useEffect(() => {
    if(!subpage) {
      setSubPage('worktime', true);
    }
  }, [subpage, setSubPage])
  
    const tabItems: TabsProps['items'] = [
      {
        key: 'worktime',
        label: 'Zeiterfassung',
        children: <EmployeeWorktime employeeId={employeeId} />,
      },
      {
        key: 'closure',
        label: 'Monatsabrechnungen',
        children: <EmployeeClosure employeeId={employeeId} employee={employee} subpage={subSubPage} />,
      },
    ];
  
    return (
      <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
          <TabsStyled items={tabItems} activeKey={subpage} onChange={newSubpage => {
            console.log("New subpage", newSubpage);
            setSubPage(newSubpage, false)}
           } />
      </div>
    )
}

export default EmployeeSettlement;